import * as React from 'react';
import { styled } from '@mui/material';
import { MuiModal } from 'ui/MuiModal';
import { AdjustmentSchemeCreateStepper } from '../forms/AdjustmentSchemeCreateStepper';
import { AdjustmentScheme } from '../adjustmentSchemeModel';

interface AdjustmentSchemesCreationModalProps {
    open: boolean;
    currencySymbol: string;
    existingSchemes: AdjustmentScheme[];
    duplicateScheme?: AdjustmentScheme;
    onClose: () => void;
    onSuccess: (scheme: AdjustmentScheme) => void;
}

const StyledMuiModal = styled(MuiModal)(({ theme }) => ({
    width: `calc(100% - ${theme.spacing(4)})`,
    maxWidth: theme.spacing(160)
}));

export const AdjustmentSchemesCreationModal: React.FC<AdjustmentSchemesCreationModalProps> = ({
    open,
    currencySymbol,
    existingSchemes,
    duplicateScheme,
    onSuccess,
    onClose
}) => (
    <StyledMuiModal open={open} onClose={onClose}>
        <AdjustmentSchemeCreateStepper
            existingSchemes={existingSchemes}
            currencySymbol={currencySymbol}
            duplicateScheme={duplicateScheme}
            onClose={onClose}
            onSuccess={onSuccess}
        />
    </StyledMuiModal>
);
